<script setup>
import { defineProps, defineEmits } from 'vue'

const emit = defineEmits(['value'])

const props = defineProps({
  name: String,
  description: String,
  required: Boolean,
  options: Array,      // Array of {value: string, label: string}
  value: Array         // Selected values
})

function toggleOption(optionValue) {
  const newValue = [...props.value]
  const index = newValue.indexOf(optionValue)

  if (index > -1) {
    newValue.splice(index, 1)
  } else {
    newValue.push(optionValue)
  }

  emit('value', newValue)
}

function isSelected(optionValue) {
  return props.value.includes(optionValue)
}
</script>

<template>
  <div>
    <div class="param-container">
      <div class="param-header">
        <span class="me-2">{{ props.name }}</span>
        <span class="badge text-bg-info">array</span>
        <span v-if="props.required" class="ms-2 badge text-bg-danger">required</span>
      </div>
      <p class="param-description">{{ props.description }}</p>

      <div class="options-grid">
        <div
          v-for="option in props.options"
          :key="option.value"
          class="option-item"
        >
          <label class="checkbox-label">
            <input
              type="checkbox"
              :checked="isSelected(option.value)"
              @change="toggleOption(option.value)"
              class="checkbox-input"
            />
            <span class="checkbox-custom"></span>
            <span class="option-label">{{ option.label }}</span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.param-container {
  padding: 1rem;
  border-radius: 10px;
  border: 1px solid #313946;
  background-color: transparent;
}

.param-header {
  display: flex;
  align-items: center;
  font-weight: normal;
  margin-bottom: 0.5rem;
}

.param-description {
  color: #6d7785;
  margin-bottom: 1rem;
  font-size: 0.9rem;
}

.options-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 0.75rem;
}

.option-item {
  display: flex;
  align-items: center;
}

.checkbox-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin: 0;
  user-select: none;
  width: 100%;
}

.checkbox-input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.checkbox-custom {
  position: relative;
  width: 18px;
  height: 18px;
  border: 2px solid #313946;
  border-radius: 4px;
  margin-right: 0.5rem;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.checkbox-input:checked ~ .checkbox-custom {
  background-color: #bf75fe;
  border-color: #bf75fe;
}

.checkbox-input:checked ~ .checkbox-custom::after {
  content: '';
  position: absolute;
  left: 5px;
  top: 2px;
  width: 4px;
  height: 8px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.checkbox-label:hover .checkbox-custom {
  border-color: #bf75fe;
}

.option-label {
  color: #ffffff;
  font-size: 0.9rem;
}

.badge {
  font-size: 0.7rem;
  padding: 0.25rem 0.5rem;
}

.text-bg-info {
  background-color: #17a2b8 !important;
  color: white !important;
}

.text-bg-danger {
  background-color: #dc3545 !important;
  color: white !important;
}
</style>
